import { WaveEventItem } from '@anm/api/modules/waveEvents';
import numberToString from '@anm/helpers/string/numberToString';
import { Component } from 'react';

import withWaveEvents, {
  WithWaveEventsInsertedProps
} from '../../HOCs/withWaveEventList';
import getStringDate from '../../helpers/getStringDate';
import routes from '../../routes';
import { selectSmallSize } from '../../store/modules/template/selectors';
import Calendar from '../Calendar';
import CalendarEvent from '../CalendarEvent';

type HocsProps = WithWaveEventsInsertedProps;

export interface CalendarEventsProps extends HocsProps {}

const goToDate = (date: Date) => {
  const { Router } = routes;

  Router.pushRoute('calendar', {
    weekDate: getStringDate(date)
  });
};

const getWaveEventIdFromUrl = (eventUrl: string) =>
  eventUrl
    .split('/')
    .pop()!
    .replace('.json', '');

class CalendarEvents extends Component<CalendarEventsProps> {
  renderEventList = (year: number, month: number, date: number) => {
    const { currentWeekEvents, startWeekDate } = this.props;
    if (!currentWeekEvents) return null;

    const currentDate = `${year}-${numberToString(month + 1)}-${numberToString(
      date
    )}`;

    const currentDateEventList = currentWeekEvents.filter(
      (event: WaveEventItem) => event.date === currentDate
    );

    const elementItems = currentDateEventList.map(
      ({ title, fullUrl, preview }: WaveEventItem) => {
        const link = {
          route: 'wave-event',
          params: {
            weekDate: startWeekDate,
            eventId: getWaveEventIdFromUrl(fullUrl)
          }
        };

        const waveEventPreview = preview && selectSmallSize(preview);

        return (
          <li key={title}>
            <CalendarEvent
              link={link}
              size={waveEventPreview && waveEventPreview.size}
              title={title}
              weight="normal"
              preview={waveEventPreview && waveEventPreview.url}
            />
          </li>
        );
      }
    );
    return <ul>{elementItems}</ul>;
  };

  render() {
    const { startWeekDate, endWeekDate } = this.props;

    return (
      <>
        <Calendar
          startWeekDate={startWeekDate}
          endWeekDate={endWeekDate}
          onStartDateChange={goToDate}
        >
          {this.renderEventList}
        </Calendar>
      </>
    );
  }
}

export default withWaveEvents(CalendarEvents);
